import React from "react";

const ListService = () => {
  return <div>ListService</div>;
};

export default ListService;
